import {
  ACQUISITION_LIST, ACQUISITION_LIST_SUCCESS, ACQUISITION_LIST_ERROR,
  ACQUISITION_PAGE_SET,
  ACQUISITION_DETAIL, ACQUISITION_DETAIL_SUCCESS, ACQUISITION_DETAIL_ERROR,
  ACQUISITION_ADD, ACQUISITION_ADD_SUCCESS, ACQUISITION_ADD_ERROR, ACQUISITION_ADD_CHANGE,
  ACQUISITION_FILTER_DETAIL_TYPE_SUCCESS,
  ACQUISITION_FILTER_DETAIL_PARENT_SUCCESS,
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: { header: { name: 'code', order: 'sorted-asc' }, page: { current: 1, rows: 1000 }, data: [], total_pages: 1 },
  detail: { loading: false, data: null },
  add: { data: { new: { code: '', name: '' } }, loading: false, message: '' },
  filters: { detail_types: [], detail_parents: [] },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ACQUISITION_LIST: return { ...state, loading: true };
    case ACQUISITION_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case ACQUISITION_LIST_ERROR: return { ...state, loading: false, error: true };
    case ACQUISITION_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case ACQUISITION_DETAIL: return { ...state, detail: { ...state.detail, loading: true } };
    case ACQUISITION_DETAIL_SUCCESS: return { ...state, detail: { loading: false, data: action.payload } };
    case ACQUISITION_DETAIL_ERROR: return { ...state, detail: { loading: false, data: null } };
    case ACQUISITION_ADD_CHANGE: return { ...state, add: { ...state.add, data: { ...state.add.data, new: { ...state.add.data.new, ...action.payload } } } };
    case ACQUISITION_ADD: return { ...state, add: { ...state.add, loading: true } };
    case ACQUISITION_ADD_SUCCESS: return { ...state, add: { ...state.add, loading: false, message: action.payload.message, data: { new: { code: '', name: '' } } } };
    case ACQUISITION_ADD_ERROR: return { ...state, add: { ...state.add, loading: false, message: action.payload.message } };
    case ACQUISITION_FILTER_DETAIL_TYPE_SUCCESS: return { ...state, filters: { ...state.filters, detail_types: action.payload } };
    case ACQUISITION_FILTER_DETAIL_PARENT_SUCCESS: return { ...state, filters: { ...state.filters, detail_parents: action.payload } };
    default: return { ...state };
  }
};
